export const environment = {
  production: true,
  version: '87af86aeb5'
};
